

















import Vue from 'vue'
export default Vue.extend({
    computed: {
        isApp(): boolean {
            return this.$store.getters.isApp
        }
    }
})
